// extracted by mini-css-extract-plugin
export default {"innerWrapper":"du-z","tooltipWrapper":"eu-z","icon":"fu-z","tooltip":"gu-z","content":"hu-z"};